import { render, staticRenderFns } from "./monthstatementDetail.vue?vue&type=template&id=6b2ad85e&scoped=true&"
import script from "./monthstatementDetail.vue?vue&type=script&lang=js&"
export * from "./monthstatementDetail.vue?vue&type=script&lang=js&"
import style0 from "./monthstatementDetail.vue?vue&type=style&index=0&id=6b2ad85e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2ad85e",
  null
  
)

export default component.exports